import { BASE_PATH } from "..";
import type { GuarantorPost } from "../../types/guarantor";
import type { SveaRequest } from "../../types/request";

export const fetchGuarantors: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/guarantor`,
	method: "GET",
});

export const assignGuarantor: SveaRequest = (applicationId: string, guarantor: GuarantorPost) => ({
	url: `${BASE_PATH}/application/${applicationId}/guarantor`,
	method: "POST",
	body: { ...guarantor },
});

export const removeGuarantor: SveaRequest = (applicationId: string, swedishNationalId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/guarantor/${swedishNationalId}`,
	method: "DELETE",
});

export const setupGuarantorAgreement: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/guarantor/setup-agreement`,
	method: "POST",
});

export const fetchGuarantorAgreement: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/guarantor/agreement`,
	method: "GET",
	headers: {
		"content-type": "application/json",
	},
});
